module.exports = __webpack_public_path__ + "img/bow.7e022471.svg";